// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/UpdateNavBar/style.css
// module id = 1719
// module chunks = 0